export enum DataType {
    REAL = 1,
    DEMO
}
